import React, { useState, useEffect } from 'react';
import api from '../services/api';

export default function ProfileSettings() {
  const [form, setForm] = useState({ display_name: '', is_public: false });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    api.get('users/me/')
      .then(({ data }) => {
        setForm({ display_name: data.display_name || '', is_public: data.is_public });
        setLoading(false);
      })
      .catch(() => {
        setError('Failed to load profile');
        setLoading(false);
      });
  }, []);

  const handleChange = e => {
    const { name, type, value, checked } = e.target;
    setForm(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setError(''); setSuccess(false);
    try {
      await api.patch('users/me/', form);
      setSuccess(true);
    } catch {
      setError('Update failed');
    }
  };

  if (loading) return <p>Loading profile…</p>;

  return (
    <form onSubmit={handleSubmit} style={{ maxWidth: 400, margin: '2rem auto' }}>
      <h2>Your Profile</h2>
      {error && <p style={{ color: 'red' }}>{error}</p>}
      {success && <p style={{ color: 'green' }}>Profile updated</p>}
      <div>
        <label>Display Name</label><br/>
        <input
          name="display_name"
          value={form.display_name}
          onChange={handleChange}
          style={{ width: '100%', padding: '0.5rem' }}
        />
      </div>
      <div style={{ marginTop: '1rem' }}>
        <label>
          <input
            type="checkbox"
            name="is_public"
            checked={form.is_public}
            onChange={handleChange}
          />{' '}
          Public Profile
        </label>
      </div>
      <button type="submit" style={{ marginTop: '1rem' }}>Save Changes</button>
    </form>
  );
}